   document.addEventListener('DOMContentLoaded', function() {
       var tabs = document.querySelectorAll('.Titletabs');
       var tabContents = document.querySelectorAll('.ES_MaterialTabList_INIT');
        tabContents.forEach(function(evt,key){
          if(key == 0){
            evt.classList.add('active')
          }
        });
        tabs.forEach(function (tab, index) {
          tab.addEventListener('click', function () {
            tabs.forEach(function (t) {
              t.classList.remove('active');
            });
            
            tabContents.forEach(function (content) {
              content.classList.remove('active');
            });
            tab.classList.add('active');
            if(tabContents[index])
            tabContents[index].classList.add('active');
          });
        });
document.querySelectorAll(".read_more_data").forEach(function(element) {
    element.addEventListener("click", function() {
        this.style.display = "none";
        var parent = this.closest(".content_has_readmore");
        var hiddenContent = parent.querySelector(".deschidden-Content");
        if (hiddenContent) {
            hiddenContent.style.display = "block";
        }
    });
});
// Get all elements with class "read_less_data" and attach a click event handler
document.querySelectorAll(".read_less_data").forEach(function(element) {
    element.addEventListener("click", function() {
        // Find the parent element with class "content_has_readmore"
        var parent = this.closest(".content_has_readmore");
        
        // Find the element with class "deschidden-Content" inside the parent and hide it
        var hiddenContent = parent.querySelector(".deschidden-Content");
        if (hiddenContent) {
            hiddenContent.style.display = "none";
        }
        
        // Find the element with class "read_more_data" inside the parent and show it
        var readMoreData = parent.querySelector(".read_more_data");
        if (readMoreData) {
            readMoreData.style.display = "inline";
        }
    });
});

   });